// extracted by mini-css-extract-plugin
module.exports = {"tile":"Tile_tile__3d9Zk","highlight":"Tile_highlight__Y44-r"};